import { render, staticRenderFns } from "./monacoEditorCustom.vue?vue&type=template&id=3f6df8fc&"
import script from "./monacoEditorCustom.vue?vue&type=script&lang=js&"
export * from "./monacoEditorCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/monacoCustom/monacoEditorCustom.vue"
export default component.exports